import { render, staticRenderFns } from "./SuggestedPackages.vue?vue&type=template&id=5e990009&scoped=true&"
import script from "./SuggestedPackages.vue?vue&type=script&lang=js&"
export * from "./SuggestedPackages.vue?vue&type=script&lang=js&"
import style0 from "./SuggestedPackages.vue?vue&type=style&index=0&id=5e990009&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e990009",
  null
  
)

export default component.exports